<script>
import { http } from "@/helpers/easyindustriaapi/config";
import { normalizeBirthdayItems } from "./birthdayItems";

export default {
  name: "BirthdaysTomorrow",
  props: {
    empresaId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      upcomingTomorrow: [],
    };
  },
  computed: {
    resolvedEmpresaId() {
      if (this.empresaId != null && this.empresaId !== "") return Number(this.empresaId);
      const currentEmpresa = JSON.parse(localStorage.getItem("currentEmpresa") || "null");
      return currentEmpresa?.id ? Number(currentEmpresa.id) : null;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.resolvedEmpresaId) {
        this.error = "Empresa não selecionada.";
        return;
      }

      this.loading = true;
      this.error = null;
      this.upcomingTomorrow = [];

      try {
        const res = await http.get(`/dashboard/birthdays/tomorrow?empresa_id=${this.resolvedEmpresaId}`);
        this.upcomingTomorrow = normalizeBirthdayItems(res?.data?.data);
      } catch (e) {
        this.error = e?.response?.data?.message || e?.message || "Erro ao carregar aniversariantes.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <b-card class="h-100 birthday-card">
    <div class="birthday-fx" aria-hidden="true">
      <span class="confetti c1"></span>
      <span class="confetti c2"></span>
      <span class="confetti c3"></span>
      <span class="confetti c4"></span>
      <span class="confetti c5"></span>
      <span class="balloon b1"></span>
      <span class="balloon b2"></span>
      <span class="balloon b3"></span>
    </div>

    <template #header>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h5 class="mb-0">Aniversariantes de amanhã</h5>
          <small class="text-muted">D+1</small>
        </div>
        <div />
      </div>
    </template>

    <b-alert v-if="error" variant="danger" show class="mb-3">{{ error }}</b-alert>

    <div v-if="!loading && !error && upcomingTomorrow.length === 0" class="text-center py-4 text-muted">
      Nenhum aniversariante amanhã.
    </div>

    <div v-if="upcomingTomorrow.length" class="list-group list-group-flush">
      <div
        v-for="item in upcomingTomorrow"
        :key="item.id"
        class="list-group-item d-flex align-items-center justify-content-between"
      >
        <div class="text-truncate">
          <div class="font-weight-semibold text-truncate">{{ item.name }}</div>
          <small class="text-muted">
            {{ item.age }} anos • {{ item.roleLabel }}<span v-if="item.dateLabel"> • {{ item.dateLabel }}</span>
          </small>
        </div>
        <i class="ri-cake-2-line text-muted"></i>
      </div>
    </div>
  </b-card>
</template>

<style scoped>
.font-weight-semibold {
  font-weight: 600;
}

.birthday-card {
  position: relative;
  overflow: hidden;
}

.birthday-fx {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  opacity: 0;
  transition: opacity 180ms ease;
}

.birthday-card :deep(.card-body),
.birthday-card :deep(.card-header) {
  position: relative;
  z-index: 1;
}

.birthday-card:hover .birthday-fx {
  opacity: 1;
}

.confetti,
.balloon {
  position: absolute;
  display: block;
  transform: translateZ(0);
}

.confetti {
  top: -12px;
  width: 10px;
  height: 14px;
  border-radius: 2px;
  opacity: 0.95;
  animation: confetti-fall 900ms ease-in-out infinite;
}

.confetti.c1 {
  left: 12%;
  background: #f72585;
  animation-delay: 0ms;
}
.confetti.c2 {
  left: 28%;
  background: #ffd166;
  animation-delay: 120ms;
}
.confetti.c3 {
  left: 52%;
  background: #4cc9f0;
  animation-delay: 240ms;
}
.confetti.c4 {
  left: 71%;
  background: #7c3aed;
  animation-delay: 360ms;
}
.confetti.c5 {
  left: 88%;
  background: #22c55e;
  animation-delay: 480ms;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(-20px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  100% {
    transform: translateY(140px) rotate(320deg);
    opacity: 0;
  }
}

.balloon {
  bottom: -44px;
  width: 34px;
  height: 44px;
  border-radius: 18px 18px 18px 18px;
  opacity: 0.9;
  animation: balloon-float 1200ms ease-in-out infinite;
  box-shadow: inset -6px -10px 0 rgba(0, 0, 0, 0.08);
}

.balloon::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  width: 2px;
  height: 18px;
  background: rgba(0, 0, 0, 0.18);
  transform: translateX(-50%);
}

.balloon::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 40px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  transform: translateX(-50%);
}

@keyframes balloon-float {
  0% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-30px) scale(1.03);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

.balloon.b1 {
  left: 18%;
  background: #f72585;
  animation-delay: 0ms;
}
.balloon.b2 {
  left: 42%;
  background: #4cc9f0;
  animation-delay: 180ms;
}
.balloon.b3 {
  left: 70%;
  background: #22c55e;
  animation-delay: 360ms;
}
</style>
